import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const LinkedIn: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] fill-black text-white', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_632_7399)">
      <g clipPath="url(#clip1_632_7399)">
        <path
          d="M22.2234 0.000244141H1.77187C0.792187 0.000244141 0 0.773682 0 1.72993V22.2659C0 23.2221 0.792187 24.0002 1.77187 24.0002H22.2234C23.2031 24.0002 24 23.2221 24 22.2706V1.72993C24 0.773682 23.2031 0.000244141 22.2234 0.000244141ZM7.12031 20.4518H3.55781V8.99556H7.12031V20.4518ZM5.33906 7.43462C4.19531 7.43462 3.27188 6.51118 3.27188 5.37212C3.27188 4.23306 4.19531 3.30962 5.33906 3.30962C6.47813 3.30962 7.40156 4.23306 7.40156 5.37212C7.40156 6.50649 6.47813 7.43462 5.33906 7.43462ZM20.4516 20.4518H16.8937V14.8831C16.8937 13.5565 16.8703 11.8456 15.0422 11.8456C13.1906 11.8456 12.9094 13.294 12.9094 14.7893V20.4518H9.35625V8.99556H12.7687V10.5612H12.8156C13.2891 9.66118 14.4516 8.70962 16.1813 8.70962C19.7859 8.70962 20.4516 11.0815 20.4516 14.1659V20.4518Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_632_7399">
        <rect width="24" height="24" fill="currentFill" transform="translate(0 0.000244141)" />
      </clipPath>

      <clipPath id="clip1_632_7399">
        <rect width="24" height="24" fill="currentFill" transform="translate(0 0.000244141)" />
      </clipPath>
    </defs>
  </svg>
);

export default LinkedIn;
